import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/recruiting/new/loading';

export const Route = createFileRoute('/_private/recruiting/new')({
  pendingComponent: Loading,
});
